import React from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import Slide from "@material-ui/core/Slide"
import Button from "@material-ui/core/Button"
import { closeAlert } from "../../actions/alert"

class Transition extends React.Component {
  render() {
    return <Slide direction="up" {...this.props} />
  }
}

class AlertComponent extends React.Component {
  handleClose = canceled => {
    this.props.dispatch(closeAlert(canceled))
  }

  render() {
    const {
      open,
      title,
      body,
      declineButtonText,
      acceptButtonText
    } = this.props
    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        open={open}
        TransitionComponent={Transition}
        // aria-labelledby="alert-dialog-slide-title"
        // aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {body}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.handleClose(true)} color="primary">
            {declineButtonText}
          </Button>
          <Button
            onClick={() => this.handleClose(false)}
            variant="contained"
            color="primary"
          >
            {acceptButtonText}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    open: state.alert.open,
    title: state.alert.title,
    body: state.alert.body,
    declineButtonText: state.alert.declineButtonText,
    acceptButtonText: state.alert.acceptButtonText
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true })
)(AlertComponent)
